import { useContext } from "react";
import { PageContext } from '../context';

function useStorageData() {

  const { productData,
    setProductData,
    materialData,
    setMaterialData,
    productPriceData,
    productList,
    sortPreset,
    setSortPreset,
    productReadyData,
    productBonusData
  } = useContext(PageContext);

  return {
    productData,
    setProductData,
    materialData,
    setMaterialData,
    productPriceData,
    productList,
    sortPreset,
    setSortPreset,
    productReadyData,
    productBonusData
  }
  
  
}

export default useStorageData;